/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyArticle,
    JsonEventPartyArticleFromJSON,
    JsonEventPartyArticleFromJSONTyped,
    JsonEventPartyArticleToJSON,
} from './JsonEventPartyArticle';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventPartyArticle
 */
export interface ApiResultOfJsonEventPartyArticle {
    /**
     * 
     * @type {JsonEventPartyArticle}
     * @memberof ApiResultOfJsonEventPartyArticle
     */
    data?: JsonEventPartyArticle;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyArticle
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventPartyArticle
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyArticle
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyArticle
     */
    result?: ApiResultOfJsonEventPartyArticleResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyArticleResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyArticleFromJSON(json: any): ApiResultOfJsonEventPartyArticle {
    return ApiResultOfJsonEventPartyArticleFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyArticleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventPartyArticle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyArticleFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyArticleToJSON(value?: ApiResultOfJsonEventPartyArticle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyArticleToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

